import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol, DecimalPipe, formatNumber } from '@angular/common';
import { isNumber } from 'util';

@Pipe({
    name: 'customnumber',
})

export class CustomNumberPipe implements PipeTransform {
    transform(
        value: string,
        digitsInfo: string = '',
        locale: string = 'en-US',
    ): string | null {
        const data = (parseFloat(value));
        if (!isNaN(data)) {
            return formatNumber(
                data,
                locale,
                digitsInfo,
            );
        } else {
            return value;
        }
    }
}
